let ownerChatAutoScrollEnabled = true;
let ownerChatSuppressKeyboardScroll = false;
let chatSmoothScrollRaf: number | null = null;
let ownerChatActiveConversationUserId: string | null = null;
let ownerChatSelectedDisplayName = '';
let ownerChatClearMode = false;

export type OwnerChatMode = 'consult' | 'order';
let ownerChatMode: OwnerChatMode = 'consult';
let ownerChatActiveOrderId: string | null = null;
let ownerChatActiveOrderTitle = '';
let ownerChatActiveCustomerUserId: string | null = null;
let ownerChatListTab: OwnerChatMode = 'order';

export function getOwnerChatAutoScrollEnabled() {
  return ownerChatAutoScrollEnabled;
}

export function setOwnerChatAutoScrollEnabled(value: boolean) {
  ownerChatAutoScrollEnabled = !!value;
}

export function getOwnerChatSuppressKeyboardScroll() {
  return ownerChatSuppressKeyboardScroll;
}

export function setOwnerChatSuppressKeyboardScroll(value: boolean) {
  ownerChatSuppressKeyboardScroll = !!value;
}

export function getChatSmoothScrollRaf() {
  return chatSmoothScrollRaf;
}

export function setChatSmoothScrollRaf(value: number | null) {
  chatSmoothScrollRaf = value;
}

export function cancelChatSmoothScrollRaf() {
  if (chatSmoothScrollRaf) {
    cancelAnimationFrame(chatSmoothScrollRaf);
    chatSmoothScrollRaf = null;
  }
}

export function getOwnerChatActiveConversationUserId() {
  return ownerChatActiveConversationUserId;
}

export function setOwnerChatActiveConversationUserId(value: string | number | null | undefined) {
  ownerChatActiveConversationUserId = value == null ? null : String(value);
}

export function getOwnerChatSelectedDisplayName() {
  return ownerChatSelectedDisplayName;
}

export function setOwnerChatSelectedDisplayName(value: string) {
  ownerChatSelectedDisplayName = String(value || '');
}

export function getOwnerChatClearMode() {
  return ownerChatClearMode;
}

export function setOwnerChatClearMode(value: boolean) {
  ownerChatClearMode = !!value;
}

export function getOwnerChatMode() {
  return ownerChatMode;
}

export function setOwnerChatMode(value: OwnerChatMode) {
  ownerChatMode = value === 'order' ? 'order' : 'consult';
}

export function getOwnerChatActiveOrderId() {
  return ownerChatActiveOrderId;
}

export function setOwnerChatActiveOrderId(value: string | null | undefined) {
  ownerChatActiveOrderId = value == null ? null : String(value);
}

export function getOwnerChatActiveOrderTitle() {
  return ownerChatActiveOrderTitle;
}

export function setOwnerChatActiveOrderTitle(value: string) {
  ownerChatActiveOrderTitle = String(value || '');
}

export function getOwnerChatActiveCustomerUserId() {
  return ownerChatActiveCustomerUserId;
}

export function setOwnerChatActiveCustomerUserId(value: string | null | undefined) {
  ownerChatActiveCustomerUserId = value == null ? null : String(value);
}

export function getOwnerChatListTab() {
  return ownerChatListTab;
}

export function setOwnerChatListTab(value: OwnerChatMode) {
  ownerChatListTab = value === 'order' ? 'order' : 'consult';
}

export function resetOwnerChatOrderContext() {
  ownerChatActiveOrderId = null;
  ownerChatActiveOrderTitle = '';
  ownerChatActiveCustomerUserId = null;
}
